import { ProcessedEvent } from '../../types'
import {
  differenceInDays,
  endOfDay,
  isAfter,
  isBefore,
  isSameDay,
  isWithinInterval,
  startOfDay,
} from 'date-fns'
import { MULTI_DAY_EVENT_HEIGHT } from '../../helpers/constants'
import { EventItem } from './EventItem'

interface MultiDayEventsProps {
  events: ProcessedEvent[]
  today: Date
  allWeekMulti: ProcessedEvent[]
  weekStart: Date
  weekEnd: Date
}

export function MultiDayEvents({
  events,
  today,
  allWeekMulti,
  weekStart,
  weekEnd,
}: MultiDayEventsProps) {
  const isFirstDayInWeek = isSameDay(weekStart, today)

  const multiDays = allWeekMulti
    .filter((e) =>
      isBefore(e.start, weekStart)
        ? isFirstDayInWeek
        : isSameDay(e.start, today)
    )
    .sort((a, b) => b.end.getTime() - a.end.getTime())

  return (
    <>
      {multiDays.map((event, i) => {
        const hasPrev = isBefore(
          startOfDay(event.start),
          weekStart
        )
        const hasNext = isAfter(endOfDay(event.end), weekEnd)
        const eventLength =
          differenceInDays(
            hasNext ? weekEnd : event.end,
            hasPrev ? weekStart : event.start
          ) + 1
        const prevNextEvents = events.filter((e) =>
          isFirstDayInWeek
            ? false
            : e.uid !== event.uid && //Exclude it's self
              isWithinInterval(today, {
                start: e.start,
                end: e.end,
              })
        )

        let index = i
        if (prevNextEvents.length) {
          index += prevNextEvents.length
        }

        return (
          <div
            key={event.uid}
            className="rs__multi_day"
            style={{
              top: index * MULTI_DAY_EVENT_HEIGHT + 45,
              width: `${100 * eventLength}%`,
            }}
          >
            <EventItem
              event={event}
              hasPrev={hasPrev}
              hasNext={hasNext}
              multiday
            />
          </div>
        )
      })}
    </>
  )
}
